module.exports = __webpack_public_path__ + "archicons.2ad47d1bcc2f6d4803bf.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TerrellDavis/Documents/GitHub/AVL/realavl/realavl/src/fonts/archicons.svg?3l3b66
// module id = ../../../../../src/fonts/archicons.svg?3l3b66
// module chunks = styles